// Profile Screens
import BasicInfo from "./OnBoarding/OnBoardingScreens/Basic/BasicInfo";
import BasicInfo_Name from "./OnBoarding/OnBoardingScreens/Basic/BasicInfo_Name";
import BasicInfo_DateOfBirthApp from "./OnBoarding/OnBoardingScreens/Basic/BasicInfo_DateOfBirthApp";
import BasicInfo_DateOfBirthWeb from "./OnBoarding/OnBoardingScreens/Basic/BasicInfo_DateOfBirthWeb";
import MoreInfo from "./OnBoarding/OnBoardingScreens/MoreInfo/MoreInfo";
import OnBoardingGender from "./OnBoarding/OnBoardingScreens/MoreInfo/OnBoardingProfile/OnBoardingGender";
import DatePreferences from "./OnBoarding/OnBoardingScreens/MoreInfo/OnBoardingProfile/DatePreferences";
import UploadProfileImages from "./OnBoarding/OnBoardingScreens/MoreInfo/OnBoardingProfile/UploadProfileImages";
import SelectExperienceOnboarding from "./OnBoarding/OnBoardingScreens/MoreInfo/OnBoardingProfile/SelectExperienceOnboarding";
import GrantLocationAccess from "./OnBoarding/OnBoardingScreens/MoreInfo/GrantLocationAccess";
import SubscribeOnboarding from "./OnBoarding/OnBoardingScreens/SubscribeOnboarding";
import OnBoardingComplete from "./OnBoarding/OnBoardingScreens/OnBoardingComplete";
import GrantLocationAccessWeb from "./OnBoarding/OnBoardingScreens/MoreInfo/GrantLocationAccessWeb";
import CompanyAdd from "./OnBoarding/OnBoardingScreens/OtherInfo/CompanyAdd";
import CityAdd from "./OnBoarding/OnBoardingScreens/OtherInfo/CityAdd";
import UseReason from "./OnBoarding/OnBoardingScreens/OtherInfo/UseReason";
import SocialLinkAdd from "./OnBoarding/OnBoardingScreens/OtherInfo/SocialLinkAdd";

const Screens = {
  BasicInfo,
  BasicInfo_Name,
  BasicInfo_DateOfBirthApp,
  BasicInfo_DateOfBirthWeb,
  MoreInfo,
  OnBoardingGender,
  DatePreferences,
  UploadProfileImages,
  SelectExperienceOnboarding,
  GrantLocationAccess,
  GrantLocationAccessWeb,
  SubscribeOnboarding,
  OnBoardingComplete,
  CompanyAdd,
  CityAdd,
  UseReason,
  SocialLinkAdd

};

export default Screens;
